export const AlertIcon = () => {
    return (
        <svg width="100%" height="100%" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M30 44.4444C30.8185 44.4444 31.5051 44.1671 32.0598 43.6124C32.6144 43.0578 32.8908 42.3721 32.8889 41.5556C32.887 40.739 32.6096 40.0533 32.0569 39.4987C31.5041 38.944 30.8185 38.6667 30 38.6667C29.1815 38.6667 28.4959 38.944 27.9431 39.4987C27.3904 40.0533 27.113 40.739 27.1111 41.5556C27.1092 42.3721 27.3865 43.0587 27.9431 43.6153C28.4997 44.1719 29.1853 44.4483 30 44.4444ZM27.1111 32.8889H32.8889V15.5556H27.1111V32.8889ZM19.1667 56L4 40.8333V19.1667L19.1667 4H40.8333L56 19.1667V40.8333L40.8333 56H19.1667ZM21.6222 50.2222H38.3778L50.2222 38.3778V21.6222L38.3778 9.77778H21.6222L9.77778 21.6222V38.3778L21.6222 50.2222Z"
                fill="url(#paint0_linear_971_23778)"/>
            <defs>
                <linearGradient id="paint0_linear_971_23778" x1="33.5862" y1="-25.0588" x2="104.867" y2="86.2422"
                                gradientUnits="userSpaceOnUse">
                    <stop stopColor="#F83700"/>
                    <stop offset="1" stopColor="#F7CB2A"/>
                </linearGradient>
            </defs>
        </svg>
    );
};